import { collection, getFirestore, onSnapshot } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { app } from '../../util/firebase'
import {AiOutlineSearch } from "react-icons/ai"
export default function ListCotisation() {

    const [cotisations, setCotisation] = useState([])
    const [filterCotisations , setFilterCotisation] =useState([])
    const [phoneNumber , setPhoneNumber ] = useState()


    useEffect(()=>{
        onSnapshot(collection(getFirestore(app), "Cotisations"),(snap)=>{
            setCotisation(snap.docs.map((medoc)=> ({...medoc.data(),id:medoc.id})))
            setFilterCotisation(snap.docs.map((medoc)=> ({...medoc.data(),id:medoc.id})))
        })
    },[])


    const filterCotisation = (value)=>{
        setPhoneNumber(value)
        let userCotisation = cotisations.filter((coti)=>{
            return coti.user.phoneNumber.includes(phoneNumber)
        })
        // cotisations.filter((cotisation=> console.log(cotisation.user.phoneNumber.includes)))
        setFilterCotisation(userCotisation)
    }
  return (
    <div>
        <div class="input-group w-75 py-3 bg-light">
            <input type="search" placeholder='Chercher par numero' class="form-control" onChange={e=> filterCotisation(e.target.value)} />
            <AiOutlineSearch />
        </div>
        <table className="table table-striped table-hover ">
            <thead>
                <tr className=''>
                    <th  >User Name</th>
                    <th >email</th>
                    <th >Description</th>                         
                    <th >Date cotisation</th>
                    <th >Facture </th>
                </tr>
            </thead>
            <tbody>
            {
                filterCotisations.map((cotisation)=>{
                    return(
                        <tr key={cotisation.id}>
                            <td>{cotisation.user.userName}</td>
                            <td>{cotisation.user.email}</td>
                            <td>{cotisation.description}</td>
                            <td>{cotisation.date.toDate().toGMTString()}</td>
                            <td><a href={cotisation.file} target='_blank' rel='noreferrer'>Telecharger </a></td>
                        </tr>
                    )})
            }
            </tbody>
        </table>
        {}
    </div>
  )
}
